/** Shared class strings for the landing page sections. */
export const LABEL = 'text-[11px] uppercase tracking-[0.22em] text-primary';
export const WRAP = 'mx-auto max-w-6xl px-5 md:px-10';
export const GLOW = 'bg-linear-to-r from-primary to-highlight bg-clip-text text-transparent';
